import React, { useState } from 'react'
 
import BeatplanList from './BeatplanList';
import BeatplanForm from './BeatplanForm';

const BeatPlan= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <BeatplanForm addForm={setFromIsShown} update={upData} />
        ) : (
          <BeatplanList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default BeatPlan